module.exports = __webpack_public_path__ + "img/bg-grid-card.2596a77f.svg";